import { z } from "zod";

export const phoneVerificationResponseSchema = z.object({
    status: z.literal(true),
    token: z.string(),
    user: z.object({
        id: z.string(),
        profileId: z.string(),
    }),
});

export const PHONE_IDENTITY_EMAIL_SUFFIX = "@phone.invalid";

export const PHONE_MEMBER_PLACEHOLDER_NAME = "Wags member";
